<template>
  <div>
    <div v-html="message"></div>
    <span>Nom de l'application: {{ __("SITE_TITLE") }}</span>
  </div>
</template>

<script>
module.exports = {
  name: "example-component",
  props: {
    username: {
      type: String,
      default: "Utilisateur",
    },
  },
  data: function () {
    return {
      message: '',
    };
  },
};
</script>

<style scoped lang="scss">
span {
  color: #555;
}
</style>